import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import PropTypes from 'prop-types';
import {ExecutionStatus, RuntimeMode} from 'constants/dataEnum';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import {useSelector} from 'react-redux';
import {getRuntimeStatus} from 'stores/selectors/runtimeSelector';
import TaskPipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskPipettingProfileWrapper';
import BroadcastTaskDescription from './TaskDescription/BroadcastTaskDescription';
import BroadcastPipettingProfile from './BroadcastPipettingProfile';

function BroadcastTaskTransfer({
  number,
  tasks,
  labware,
  labwareState,
  showEditButton,
  isHighlighted,
  onEdit,
  onShowMenuContext,
  readOnly,
  runtimeMode,
  executionStatus,
}) {
  const runtimeStatus = useSelector(getRuntimeStatus);
  let transferName = '';
  if (number === 1) transferName = 'Source well(s)';
  else if (number === 2) transferName = 'Destination well(s)';
  else transferName = 'Destination volume';
  const isShowPipettingProfile =
    !readOnly &&
    ((runtimeMode && runtimeStatus === RuntimeMode.PAUSED && executionStatus === ExecutionStatus.NONE) || !runtimeMode);

  return (
    <TaskWrapper disableDrag isSelected={isHighlighted} onContextMenu={onShowMenuContext}>
      <TaskNumber number={number} isHighlighted={isHighlighted} />
      <TaskTitle
        title={`Broadcast: ${transferName}`}
        description={
          <BroadcastTaskDescription number={number} labware={labware} tasks={tasks} labwareState={labwareState} />
        }
      />
      {!runtimeMode && !readOnly && showEditButton && (
        <TaskAction
          onEdit={onEdit}
          // onDelete={() => {}}
          // onIgnoreCheckboxChanged={() => {}}
        />
      )}
      {isShowPipettingProfile && (
        <TaskPipettingProfileWrapper>
          <BroadcastPipettingProfile task={tasks[0]} runtimeMode={runtimeMode} />
        </TaskPipettingProfileWrapper>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

BroadcastTaskTransfer.propTypes = {
  number: PropTypes.number.isRequired,
  labware: PropTypes.object.isRequired,
  labwareState: PropTypes.object.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  tasks: PropTypes.array.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onShowMenuContext: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  runtimeMode: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
};

export default BroadcastTaskTransfer;
